"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBackgroundCheckScreeningsDto = instanceOfBackgroundCheckScreeningsDto;
exports.BackgroundCheckScreeningsDtoFromJSON = BackgroundCheckScreeningsDtoFromJSON;
exports.BackgroundCheckScreeningsDtoFromJSONTyped = BackgroundCheckScreeningsDtoFromJSONTyped;
exports.BackgroundCheckScreeningsDtoToJSON = BackgroundCheckScreeningsDtoToJSON;
exports.BackgroundCheckScreeningsDtoToJSONTyped = BackgroundCheckScreeningsDtoToJSONTyped;
const BackgroundCheckScreeningStatusDto_1 = require("./BackgroundCheckScreeningStatusDto");
/**
 * Check if a given object implements the BackgroundCheckScreeningsDto interface.
 */
function instanceOfBackgroundCheckScreeningsDto(value) {
    if (!('orderedAt' in value) || value['orderedAt'] === undefined)
        return false;
    if (!('screenings' in value) || value['screenings'] === undefined)
        return false;
    return true;
}
function BackgroundCheckScreeningsDtoFromJSON(json) {
    return BackgroundCheckScreeningsDtoFromJSONTyped(json, false);
}
function BackgroundCheckScreeningsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderedAt': (json['orderedAt'] == null ? null : new Date(json['orderedAt'])),
        'screenings': (json['screenings'].map(BackgroundCheckScreeningStatusDto_1.BackgroundCheckScreeningStatusDtoFromJSON)),
    };
}
function BackgroundCheckScreeningsDtoToJSON(json) {
    return BackgroundCheckScreeningsDtoToJSONTyped(json, false);
}
function BackgroundCheckScreeningsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderedAt': (value['orderedAt'] == null ? null : value['orderedAt'].toISOString()),
        'screenings': (value['screenings'].map(BackgroundCheckScreeningStatusDto_1.BackgroundCheckScreeningStatusDtoToJSON)),
    };
}
//# sourceMappingURL=BackgroundCheckScreeningsDto.js.map